import { useIntl } from 'react-intl'
import {
  mdiHomeCityOutline,
  mdiAccountMultipleOutline,
  mdiFormatListBulleted,
  mdiLicense,
  mdiFileDocumentOutline,
  mdiFileCodeOutline,
  mdiCheck,
} from '@mdi/js'

import routes from 'app/routes'
import {
  StyledHeaderLinks,
  StyledHeaderLink,
  StyledHeaderLinkIcon,
  StyledSelectedHeaderLinkIcon,
  StyledHeaderLinkTitle,
} from './styles'
import { HeaderLinkMessages } from './messages'
import { useAppSelector } from 'app/hooks'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import { DOMAIN_ADMIN_SOMEWHERE } from 'features/auth/permissions/consts'
import Permissions from 'features/auth/permissions'

interface HeaderLinksProps {
  isMobile?: boolean
}

function HeaderLinks(props: HeaderLinksProps) {
  const { isMobile } = props
  const { formatMessage } = useIntl()

  const currentRootId = useAppSelector(currentRootDomainIdSelector)

  return (
    <StyledHeaderLinks isMobile={isMobile}>
      <StyledHeaderLink to={routes.homesJobs(currentRootId)}>
        <StyledHeaderLinkTitle>
          <StyledHeaderLinkIcon path={mdiHomeCityOutline} size={1} />
          {formatMessage(HeaderLinkMessages.jobsLink)}
        </StyledHeaderLinkTitle>
        <StyledSelectedHeaderLinkIcon path={mdiCheck} size={1} />
      </StyledHeaderLink>

      <StyledHeaderLink to={routes.templates(currentRootId)}>
        <StyledHeaderLinkTitle>
          <StyledHeaderLinkIcon path={mdiFileDocumentOutline} size={1} />
          {formatMessage(HeaderLinkMessages.templatesLink)}
        </StyledHeaderLinkTitle>
        <StyledSelectedHeaderLinkIcon path={mdiCheck} size={1} />
      </StyledHeaderLink>

      <StyledHeaderLink to={routes.profiles(currentRootId)}>
        <StyledHeaderLinkTitle>
          <StyledHeaderLinkIcon path={mdiFileCodeOutline} size={1} />
          {formatMessage(HeaderLinkMessages.profilesLink)}
        </StyledHeaderLinkTitle>
        <StyledSelectedHeaderLinkIcon path={mdiCheck} size={1} />
      </StyledHeaderLink>

      <StyledHeaderLink to={routes.licenses(currentRootId)}>
        <StyledHeaderLinkTitle>
          <StyledHeaderLinkIcon path={mdiLicense} size={1} />
          {formatMessage(HeaderLinkMessages.licensesLink)}
        </StyledHeaderLinkTitle>
        <StyledSelectedHeaderLinkIcon path={mdiCheck} size={1} />
      </StyledHeaderLink>

      <StyledHeaderLink to={routes.team(currentRootId)}>
        <StyledHeaderLinkTitle>
          <StyledHeaderLinkIcon path={mdiAccountMultipleOutline} size={1} />
          {formatMessage(HeaderLinkMessages.teamLink)}
        </StyledHeaderLinkTitle>
        <StyledSelectedHeaderLinkIcon path={mdiCheck} size={1} />
      </StyledHeaderLink>

      <Permissions allow={[DOMAIN_ADMIN_SOMEWHERE]}>
        <StyledHeaderLink to={routes.audit(currentRootId)}>
          <StyledHeaderLinkTitle>
            <StyledHeaderLinkIcon path={mdiFormatListBulleted} size={1} />
            {formatMessage(HeaderLinkMessages.auditLink)}
          </StyledHeaderLinkTitle>
          <StyledSelectedHeaderLinkIcon path={mdiCheck} size={1} />
        </StyledHeaderLink>
      </Permissions>
    </StyledHeaderLinks>
  )
}

export default HeaderLinks
